import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

import Logo from "../../../assets/images/logo.png";
import ArrowRightIcon from "../../../assets/images/arrowright.svg";

// Add these imports for your help images
import Help1v4 from "../../../assets/images/1v4-help.png";
import Help1v1 from "../../../assets/images/1v1-help.png";

import moment from "moment";

import "./index.css";
import { Button, ToggleButton, ToggleButtonGroup } from "react-bootstrap";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";

import { SET_PAYOUT, SPORT_ADD, USER_UPDATE } from "../../../store/actionTypes";
import { DEV_API, PAYOUT, PAYOUT_TYPE, WIN_POINT_RULES, WIN_POINT_RULES_1V1 } from "../../../const";
import CustomModal from "../../../components/Modal/modal";
import Template from "../Template";
import { getRandomNumber } from "../../../func";
import { getPlayerNames } from "../..";

const SelectPoint = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { user } = useSelector((state) => state.auth);
    const {
        playList,
        team1Idx,
        eventId,
        sportCategory,
        eventDate,
        primaryColor,
        secondaryColor,
        editPrimaryTeam,
    } = useSelector((state) => state.sport);

    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [creditLimitModal, setCreditLimitModal] = useState(false);
    const [gamePoint, setGamePoint] = useState(10);
    const [payout, setPayout] = useState(1);
    const [submitting, setSubmitting] = useState(false);
    const [showToast, setShowToast] = useState(false);
    // State for help modal
    const [showHelpModal, setShowHelpModal] = useState(false);
    const [helpType, setHelpType] = useState(""); // "1V4" or "1V1"

    const startPos = getRandomNumber();
    const { name1, name2, name3, name4 } = getPlayerNames(
        startPos,
        user.name,
        payout
    );

    useEffect(() => {
        if (!modalIsOpen && showToast) {
            toast("There are some active paid games.");
            setShowToast(false); // reset
        }
    }, [modalIsOpen, showToast]);

    const handleGamePoint = (val) => {
        setGamePoint(val);
        dispatch({ type: SPORT_ADD, payload: { point: val } });
        dispatch({ type: SET_PAYOUT, payload: { payout: payout } });
    };

    const handleGotoPayment = () => {
        handleGame();
    };

    // Show help image modal
    const handleHelpClick = (type) => {
        setHelpType(type);
        setShowHelpModal(true);
    };

    const createGame = async () => {
        const userRes = await axios.put(`${DEV_API}/api/users`, {
            search: { _id: user._id },
            modify: {
                balance: user.balance - gamePoint,
            },
        });

        if (userRes.data.success) {
            dispatch({
                type: USER_UPDATE,
                payload: { user: userRes.data.result },
            });
        }

        let gameRes = await axios.get(`${DEV_API}/api/games/many`, {
            params: {
                player: user._id,
                win: -1,
            }
        })

        // Check if there are any active paid games for the user
        if (gameRes.data.success) {
            const activeGames = gameRes.data.totalGames || 0;
            console.log(activeGames, "activeGames");
            if (activeGames > 0) {
                setModalIsOpen(false);
                showToast(true);
                return;
            }
        } else {
            return;
        }

        let playerNames = ['-', '-', '-', '-'];
        const closetScorePair = await axios.post(`${DEV_API}/api/games/getClosetScorePair`, {
            event: eventId,
            selectedTeam: team1Idx,
            sportCategory,
            payout,
        });

        if (payout == PAYOUT_TYPE["1V1"]) {//In 1v1 game, we need to set the player names to 'X' for the closet score pair
            // let names = [user.name, 'P2'];
            let closetScore = closetScorePair?.data?.result || [];
            // closetScorePair?.data?.result.forEach((index, i) => {
            //     playNames[index] = names[i]; // or any value you want
            // });
            playerNames[closetScore[0]] = user.name; // Player 1
            playerNames[closetScore[1]] = 'P2'; // Player 2
        } else {
            playerNames = [name1, name2, name3, name4];
        }

        // Create the game with the provided data
        const response = await axios.post(`${DEV_API}/api/games`, {
            player: user._id,
            event: eventId,
            teams: playList.boxscore.teams,
            sportCategory,
            startPos,
            payout,
            closetScorePair: closetScorePair.data.result,
            playerNames,
            player1Name: name1,
            player2Name: name2,
            player3Name: name3,
            player4Name: name4,
            entryPoint: gamePoint,
            winPoint:
                payout == 1
                    ? WIN_POINT_RULES[gamePoint]
                    : WIN_POINT_RULES_1V1[gamePoint],
            selectedTeam: team1Idx,
        });

        if (response.data.success) {
            dispatch({
                type: SPORT_ADD,
                payload: {
                    sportCategory,
                    eventId,
                    team1Idx,
                    startPos,
                    primaryColor,
                    secondaryColor,
                    editPrimaryTeam,
                    payout,
                    closetScorePair,
                    playerNames,
                    point: gamePoint,
                    player1Name: name1,
                    player2Name: name2,
                    player3Name: name3,
                    player4Name: name4,
                    isFree: false,
                    ...response.data.result,
                },
            });

            navigate("/play", {
                state: {
                    sportCategory,
                    eventId,
                    team1Idx,
                    startPos,
                    primaryColor,
                    secondaryColor,
                    editPrimaryTeam,
                    point: gamePoint,
                    payout,
                    closetScorePair,
                    playerNames,
                    player1Name: name1,
                    player2Name: name2,
                    player3Name: name3,
                    player4Name: name4,
                    isFree: false,
                    ...response.data.result,
                },
            });
        } else {
            toast(response.data.message);
        }
    };

    const handleGame = async () => {
        if (submitting) return;
        setSubmitting(true);

        if (gamePoint > user.creditLimit + user.balance) {
            setCreditLimitModal(true);
            return;
        }

        const payment = user.payment;
        try {
            if (
                !payment ||
                (!payment.venmo &&
                    !payment.paypal &&
                    !payment.cashApp &&
                    !payment.zelle)
            ) {
                navigate("/payments");
            } else {
                setModalIsOpen(true);
            }
        } catch (error) {
            console.error("Submission error:", error);
            toast("Something went wrong.");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <>
            <Template>
                <div className="screen-3-section">
                    <div className="screen-3-content">
                        <div className="screen-top-part">
                            <div className="logo-part">
                                <Link to="/">
                                    <img
                                        src={Logo}
                                        alt="logo"
                                        className="img-fluid"
                                    />
                                </Link>
                            </div>
                            <span className="screen-title">Your Game</span>
                            <div className="select-team-group">
                                <div className="select-team">
                                    <div className="team-image">
                                        {playList.boxscore ? (
                                            <img
                                                src={
                                                    playList.boxscore.teams[0]
                                                        .team.logo
                                                }
                                                alt={
                                                    playList.boxscore &&
                                                    playList.boxscore.teams[0]
                                                        .team.shortDisplayName
                                                }
                                                style={{
                                                    width: 43,
                                                    height: 43,
                                                }}
                                            />
                                        ) : (
                                            <div></div>
                                        )}
                                    </div>
                                    <span>
                                        {playList.boxscore &&
                                            playList.boxscore.teams[0].team
                                                .shortDisplayName}
                                    </span>
                                </div>
                                <div className="opposite-part">
                                    vs{" "}
                                    <span>
                                        {eventDate &&
                                            moment(eventDate).format(
                                                "M/D h:mm"
                                            )}
                                    </span>
                                </div>
                                <div className="select-team">
                                    <div className="team-image">
                                        {playList.boxscore ? (
                                            <img
                                                src={
                                                    playList.boxscore.teams[1]
                                                        .team.logo
                                                }
                                                alt={
                                                    playList.boxscore &&
                                                    playList.boxscore.teams[1]
                                                        .team.shortDisplayName
                                                }
                                                style={{
                                                    width: 43,
                                                    height: 43,
                                                }}
                                                className="img-fluid"
                                            />
                                        ) : (
                                            <div></div>
                                        )}
                                    </div>
                                    <span>
                                        {playList.boxscore &&
                                            playList.boxscore.teams[1].team
                                                .shortDisplayName}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="select-money-block">
                            <span className="screen-purple-glow-title">
                                PayOuts
                            </span>
                            <div className="fee-block">
                                <div className="fee-info">
                                    <p>
                                        ${gamePoint} <span>Entry Fee</span>
                                    </p>
                                </div>
                                <div className="">
                                    <img
                                        src={ArrowRightIcon}
                                        alt="arrow"
                                        className="img-fluid"
                                    />
                                </div>
                                <div className="fee-info">
                                    <p>
                                        $
                                        {payout == 1
                                            ? WIN_POINT_RULES[gamePoint]
                                            : WIN_POINT_RULES_1V1[
                                            gamePoint
                                            ]}{" "}
                                        <span>Payout</span>
                                    </p>
                                </div>
                            </div>

                            {/* === UPDATED Payout Buttons Section WITH HELP ICONS === */}
                            <div
                                className="px-3 pt-4 pb-2 d-flex justify-content-between"
                                style={{ gap: 24 }}>
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                    }}>
                                    <Button
                                        size="lg"
                                        variant={
                                            payout == 1
                                                ? "primary"
                                                : "secondary"
                                        }
                                        onClick={() => setPayout(1)}
                                        style={{ minWidth: 80 }}>
                                        1V4
                                    </Button>
                                    <button
                                        type="button"
                                        className="help-icon-btn"
                                        style={{
                                            marginLeft: 8,
                                            border: "none",
                                            borderRadius: "50%",
                                            width: 24,
                                            height: 24,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            background:
                                                "radial-gradient(circle at 20% 10%, #444 10%,rgb(5, 5, 5) 100%)",
                                            boxShadow: "0 1px 4px #000a",
                                            cursor: "pointer",
                                            padding: 0,
                                        }}
                                        onClick={() => handleHelpClick("1V4")}
                                        aria-label="1V4 help">
                                        <svg
                                            width="22"
                                            height="22"
                                            viewBox="0 0 24 24"
                                            style={{ display: "block" }}>
                                            <text
                                                x="12"
                                                y="16"
                                                textAnchor="middle"
                                                fontSize="16"
                                                fill="#fff"
                                                fontWeight="bold"
                                                fontFamily="Arial"
                                                style={{
                                                    filter: "drop-shadow(0 1px 1px #0008)",
                                                }}>
                                                ?
                                            </text>
                                        </svg>
                                    </button>
                                </div>
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                    }}>
                                    <Button
                                        size="lg"
                                        variant={
                                            payout == 2
                                                ? "primary"
                                                : "secondary"
                                        }
                                        onClick={() => setPayout(2)}
                                        style={{ minWidth: 80 }}>
                                        1V1
                                    </Button>
                                    <button
                                        type="button"
                                        className="help-icon-btn"
                                        style={{
                                            marginLeft: 8,
                                            border: "none",
                                            borderRadius: "50%",
                                            width: 24,
                                            height: 24,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            background:
                                                "radial-gradient(circle at 20% 10%, #444 10%,rgb(5, 5, 5) 100%)",
                                            boxShadow: "0 1px 4px #000a",
                                            cursor: "pointer",
                                            padding: 0,
                                        }}
                                        onClick={() => handleHelpClick("1V1")}
                                        aria-label="1V1 help">
                                        <svg
                                            width="22"
                                            height="22"
                                            viewBox="0 0 24 24"
                                            style={{ display: "block" }}>
                                            <text
                                                x="12"
                                                y="16"
                                                textAnchor="middle"
                                                fontSize="16"
                                                fill="#fff"
                                                fontWeight="bold"
                                                fontFamily="Arial"
                                                style={{
                                                    filter: "drop-shadow(0 1px 1px #0008)",
                                                }}>
                                                ?
                                            </text>
                                        </svg>
                                    </button>
                                </div>
                            </div>

                            <div className="user-select-money">
                                <ToggleButtonGroup
                                    type="radio"
                                    name="options"
                                    value={gamePoint}
                                    onChange={handleGamePoint}
                                    className="mb-2 px-3">
                                    {/* <ToggleButton
                                        id="radio-1"
                                        value={5}
                                        variant="outline-primary"
                                        className="btn-custom">
                                        $5
                                    </ToggleButton> */}
                                    <ToggleButton
                                        id="radio-2"
                                        value={10}
                                        variant="outline-primary"
                                        className="btn-custom">
                                        $10
                                    </ToggleButton>
                                    <ToggleButton
                                        id="radio-3"
                                        value={25}
                                        variant="outline-primary"
                                        className="btn-custom">
                                        $25
                                    </ToggleButton>
                                    <ToggleButton
                                        id="radio-4"
                                        value={50}
                                        variant="outline-primary"
                                        className="btn-custom">
                                        $50
                                    </ToggleButton>
                                    <ToggleButton
                                        id="radio-5"
                                        value={100}
                                        variant="outline-primary"
                                        className="btn-custom">
                                        $100
                                    </ToggleButton>
                                </ToggleButtonGroup>
                            </div>
                            <div className="text-center">
                                <span className="text-white text-center">
                                    Play First and Pay Later
                                </span>
                                <p className="text-secondary">
                                    *BallHog entry fees are not requested until
                                    after the game is completed
                                </p>
                            </div>
                            <div className="d-flex justify-content-center py-3">
                                <Button
                                    variant="danger"
                                    onClick={() => {
                                        navigate("/");
                                    }}
                                    style={{ marginRight: 20, width: 120 }}>
                                    CANCEL
                                </Button>
                                <Button
                                    variant="primary"
                                    onClick={handleGotoPayment}
                                    style={{ width: 120 }}>
                                    NEXT
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </Template>

            <CustomModal
                modalIsOpen={modalIsOpen}
                setModalIsOpen={setModalIsOpen}
                border={3}
                primaryColor="#343a40"
                backgroundColor="#fff"
                onRequestClose={() => setModalIsOpen(false)}>
                <div className="float-left text-center mt-3">
                    <span
                        className="text-black"
                        style={{
                            fontFamily: "BigBlackBear",
                            fontWeight: 900,
                            fontSize: 28,
                            fontStyle: "italic",
                        }}>
                        Your Game
                    </span>
                    <div
                        className="screen-top-part"
                        style={{
                            borderRadius: 0,
                            padding: 10,
                            borderRadius: 20,
                            background:
                                "linear-gradient(180deg, #211621 0%, #FFF 100%)",
                        }}>
                        <div className="select-team-group">
                            <div className="select-team">
                                <div className="team-image">
                                    {playList.boxscore ? (
                                        <img
                                            src={
                                                playList.boxscore.teams[0].team
                                                    .logo
                                            }
                                            alt={
                                                playList.boxscore &&
                                                playList.boxscore.teams[0].team
                                                    .shortDisplayName
                                            }
                                            style={{ width: 43, height: 43 }}
                                        />
                                    ) : (
                                        <div></div>
                                    )}
                                </div>
                                <span className="text-black">
                                    {playList.boxscore &&
                                        playList.boxscore.teams[0].team
                                            .shortDisplayName}
                                </span>
                            </div>
                            <div className="opposite-part">
                                vs{" "}
                                <span>
                                    {eventDate &&
                                        moment(eventDate).format("M/D h:mm")}
                                </span>
                            </div>
                            <div className="select-team">
                                <div className="team-image">
                                    {playList.boxscore ? (
                                        <img
                                            src={
                                                playList.boxscore.teams[1].team
                                                    .logo
                                            }
                                            alt={
                                                playList.boxscore &&
                                                playList.boxscore.teams[1].team
                                                    .shortDisplayName
                                            }
                                            style={{ width: 43, height: 43 }}
                                            className="img-fluid"
                                        />
                                    ) : (
                                        <div></div>
                                    )}
                                </div>
                                <span className="text-black">
                                    {playList.boxscore &&
                                        playList.boxscore.teams[1].team
                                            .shortDisplayName}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="select-money-block">
                        <span
                            className="text-black"
                            style={{
                                fontFamily: "BigBlackBear",
                                fontWeight: 900,
                                fontSize: 28,
                                fontStyle: "italic",
                            }}>
                            Your PayOut
                        </span>
                        <div
                            className="fee-block"
                            style={{ borderRadius: 0, padding: 20 }}>
                            <div className="fee-info">
                                <p>
                                    ${gamePoint} <span>Entry Fee</span>
                                </p>
                            </div>
                            <div style={{ padding: "0 30px" }}>
                                <img
                                    src={ArrowRightIcon}
                                    alt="arrow"
                                    className="img-fluid"
                                />
                            </div>
                            <div className="fee-info">
                                <p>
                                    $
                                    {payout == 1
                                        ? WIN_POINT_RULES[gamePoint]
                                        : WIN_POINT_RULES_1V1[gamePoint]}{" "}
                                    <span>Payout</span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <p className="pt-3">
                        *BallHog entry fees are NOT requested until after the
                        game is completed
                    </p>
                    <div className="mt-3">
                        <Button
                            className="btn btn-primary"
                            onClick={createGame}
                            disabled={submitting}>
                            Submit
                        </Button>
                    </div>
                </div>
            </CustomModal>

            {/* ==== HELP IMAGE MODAL ==== */}
            <CustomModal
                modalIsOpen={showHelpModal}
                setModalIsOpen={setShowHelpModal}
                onRequestClose={() => setShowHelpModal(false)}
                style={{ maxWidth: "100px" }}
                primaryColor="#222">
                <div style={{ textAlign: "center" }}>
                    <img
                        src={helpType === "1V4" ? Help1v4 : Help1v1}
                        alt={helpType === "1V4" ? "1V4 Help" : "1V1 Help"}
                    />
                </div>
            </CustomModal>

            <CustomModal
                modalIsOpen={creditLimitModal}
                primaryColor="#000"
                setModalIsOpen={setCreditLimitModal}
                onRequestClose={() => setCreditLimitModal(false)}
                backgroundColor="#FDDA2F">
                <div
                    className="mx-4 text-center"
                    style={{ fontFamily: "BigBlackBear" }}>
                    <h3>Over Credit Limit</h3>
                    <div>
                        <p>
                            Text
                            <br />
                            808-272-3878
                            <br />
                            To request credit limit increase
                        </p>
                    </div>
                </div>
            </CustomModal>
        </>
    );
};

export default SelectPoint;
